import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { Depot, ModelID } from '@/types';
import { get } from '@/utils/api';
import { useQuery } from '@tanstack/react-query';
import { DepotSearchParams, featureKeys, featurePath } from '.';

type QueryFnType = typeof fetchDepots;

type UseDepotsOptions = {
  location: ModelID;
  search?: DepotSearchParams;
  config?: QueryConfig<QueryFnType>;
};

const ONE_HOUR = 1000 * 60 * 60;

export const fetchDepots = (location: ModelID, search: DepotSearchParams = {}) =>
  get<Depot[]>(`${featurePath}?franchise_id=${location}`, search);

export const useDepots = ({ location, search = {}, config = {} }: UseDepotsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    staleTime: ONE_HOUR,
    queryKey: featureKeys.list(location, search),
    queryFn: () => fetchDepots(location, search),
  });
};
